export const PricingInfoFields = {
  heading: {
    type: "custom",
    label: "Heading",
    metadata: {
      source: "ai",
      description: "Section heading (e.g. 'Transparent Pricing')",
      seo: true,
      key: "pricing.heading",
    },
  },
  subheading: {
    type: "custom",
    label: "Subheading",
    metadata: {
      source: "ai",
      description: "Brief introduction (15-20 words)",
      seo: false,
      key: "pricing.subheading",
    },
  },
  priceRange: {
    type: "text",
    label: "Price Range",
    metadata: {
      source: "data",
      description: "Price or price range (e.g., '150-500' or 'Starting at 99')",
    },
  },
  priceNote: {
    type: "text",
    label: "Price Note",
    metadata: {
      source: "data",
      description: "Additional pricing context (e.g., 'Per service call')",
    },
  },
  ctaText: {
    type: "text",
    label: "CTA Button Text",
    metadata: {
      source: "manual",
    },
  },
  ctaUrl: {
    type: "text",
    label: "CTA Button URL",
    metadata: {
      source: "manual",
    },
  },
  showFreeEstimate: {
    type: "radio",
    label: "Show Free Estimate Text",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
    metadata: {
      source: "manual",
    },
  },
  features: {
    type: "array",
    label: "Included Features",
    metadata: {
      source: "ai",
      description: "What's included with this service/pricing",
    },
    getItemSummary: (item: string) => item || "New Feature",
    arrayFields: {
      feature: {
        type: "text",
        label: "Feature",
      },
    },
    defaultItemProps: "New feature",
  },
  backgroundColor: {
    type: "text",
    label: "Background Color (optional)",
    metadata: {
      source: "manual",
    },
  },
} as const;
